import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';

type Props = ModalProps<{ monthlyCost: number }>;

const ConfirmReactivateIdProtect = ({ payload, confirmAction }: Props) => {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('ConfirmReactivateIdProtect.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('ConfirmReactivateIdProtect.body')}</p>
        <DataList>
          <DataListItem>
            <DataListLabel>{t('ConfirmReactivateIdProtect.monthlyCost')}</DataListLabel>
            <DataListValue>{t('Common:money', { amount: payload.monthlyCost })}</DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <Button onClick={() => confirmAction?.()}>{t('ConfirmReactivateIdProtect.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default ConfirmReactivateIdProtect;
